import React, { lazy, Suspense } from 'react';

/**
 * 首页
 */
const HomeChunk = lazy(() => import('../pages/Home'));
const Home = (props) => {
    return (
        <Suspense fallback={null}>
            <HomeChunk {...props} />
        </Suspense>
    );
};

/**
 * 人才推荐
 */
const RecommendChunk = lazy(() => import('../pages/Recommend'));
const Recommend = (props) => {
    return (
        <Suspense fallback={null}>
            <RecommendChunk {...props} />
        </Suspense>
    );
};

/**
 * 实时动态
 */
const DynamicChunk = lazy(() => import('../pages/Dynamic'));
const Dynamic = (props) => {
    return (
        <Suspense fallback={null}>
            <DynamicChunk {...props} />
        </Suspense>
    );
};

/**
 * 员工退回
 */
const ReturnFormChunk = lazy(() => import('../pages/ReturnForm'));
const ReturnForm = (props) => {
    return (
        <Suspense fallback={null}>
            <ReturnFormChunk {...props} />
        </Suspense>
    );
};

/**
 * 好友推荐
 */
const RecommendFormChunk = lazy(() => import('../pages/RecommendForm'));
const RecommendForm = (props) => {
    return (
        <Suspense fallback={null}>
            <RecommendFormChunk {...props} />
        </Suspense>
    );
};

/**
 * 内部转单
 */
const ChangeOrderFormChunk = lazy(() => import('../pages/ChangeOrderForm'));
const ChangeOrderForm = (props) => {
    return (
        <Suspense fallback={null}>
            <ChangeOrderFormChunk {...props} />
        </Suspense>
    );
};

/**
 * 退回员工动态
 */
const DynamicReturnChunk = lazy(() => import('../pages/DynamicReturn'));
const DynamicReturn = (props) => {
    return (
        <Suspense fallback={null}>
            <DynamicReturnChunk {...props} />
        </Suspense>
    );
};

/**
 * 好友推荐动态
 */
const DynamicRecommendChunk = lazy(() => import('../pages/DynamicRecommend'));
const DynamicRecommend = (props) => {
    return (
        <Suspense fallback={null}>
            <DynamicRecommendChunk {...props} />
        </Suspense>
    );
};

/**
 * 招聘转单动态
 */
const DynamicChangeOrderChunk = lazy(() => import('../pages/DynamicChangeOrder'));
const DynamicChangeOrder = (props) => {
    return (
        <Suspense fallback={null}>
            <DynamicChangeOrderChunk {...props} />
        </Suspense>
    );
};

/**
 * 招聘转单动态
 */
const ChangeOrderProgressChunk = lazy(() => import('../pages/ChangeOrderProgress'));
const ChangeOrderProgress = (props) => {
    return (
        <Suspense fallback={null}>
            <ChangeOrderProgressChunk {...props} />
        </Suspense>
    );
};

export default [
    {
        title: 'FESCO 招聘供需采集站',
        key: '首页',
        path: '/',
        component: Home,
        exact: true,
    },
    {
        title: 'FESCO 招聘供需采集站',
        key: '人才推荐',
        path: '/recommend',
        component: Recommend,
        exact: true,
    },
    {
        title: 'FESCO 招聘供需采集站',
        key: '实时动态',
        path: '/dynamic',
        component: Dynamic,
        exact: true,
    },
    {
        title: 'FESCO 招聘供需采集站',
        key: '实时动态',
        path: '/return-form',
        component: ReturnForm,
        exact: true,
    },
    {
        title: 'FESCO 招聘供需采集站',
        key: '好友推荐',
        path: '/recommend-form',
        component: RecommendForm,
        exact: true,
    },
    {
        title: 'FESCO 招聘供需采集站',
        key: '内部转单',
        path: '/change-order',
        component: ChangeOrderForm,
        exact: true,
    },
    {
        title: 'FESCO 招聘供需采集站',
        key: '员工退回动态',
        path: '/dynamic-return',
        component: DynamicReturn,
        exact: true,
    },
    {
        title: 'FESCO 招聘供需采集站',
        key: '好友推荐动态',
        path: '/dynamic-recommend',
        component: DynamicRecommend,
        exact: true,
    },
    {
        title: 'FESCO 招聘供需采集站',
        key: '招聘转单动态',
        path: '/dynamic-change-order',
        component: DynamicChangeOrder,
        exact: true,
    },
    {
        title: 'FESCO 招聘供需采集站',
        key: '招聘转单进展',
        path: '/change-order-progress',
        component: ChangeOrderProgress,
        exact: true,
    },
];
